import buildLocationEmployeeMetricValuesHook from '../utils/buildLocationEmployeeMetricValuesHook'

export const dhWbListEmployeeDeliveryDataConfigs = {
  employeeName: 'string',
  checkCount: 'number',
  deliveryTotalOrderCountDoordash: 'number',
  deliveryOrderWithAnyIssuePercentDoordash: 'percent',
  deliveryCancelledOrderPercentDoordash: 'percent',
  deliveryInaccurateOrderPercentDoordash: 'percent',
  deliveryDelayedOrderPercentDoordash: 'percent',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  deliveryCustomerPositiveRatingCountPercentDoordash: 'percent',
} as const

const useListEmployeeDeliveryData = buildLocationEmployeeMetricValuesHook({
  codes: ['delivery_customer_positive_rating_count_percent_doordash'],
  groups: ['Expo Module - Delivery Data'],
})

export default useListEmployeeDeliveryData
